import { restClient } from '../../client';
import { AppointmentRecurring, AppointmentSlotDuration, ServiceType } from '../../resources';


export type CreateTherapyAppointmentInput = {
  is_new_patient: boolean;
  notes: string;
  recurring: AppointmentRecurring;
  time_start: string;
  is_working_time: boolean;
  provider_id?: string;
  patient_id?: string;
  match_uuid?: string;
  matching?: boolean;
  timezone?: string;
  duration?: AppointmentSlotDuration;
  service_type?: ServiceType;
  practice_location_id?: string;
};


export type CreateTherapyAppointmentOutput = {
  created: boolean;
  status: string;
  appointment_uuid?: string;
  error?: string;
};


export const createTherapyAppointment = restClient.createRequest<CreateTherapyAppointmentInput, CreateTherapyAppointmentOutput>({
  url: '/appointment/create',
  method: 'POST',
});
